import React from 'react';
import { Rating } from '@tvg/fuse/rating';
import analyticsEvent from 'services/analytic/analytic-service';
import scrollElementIntoView from '@sd-utility/scrollelementintoview';
import styles from './StarRating.module.css';

type Props = {
  reviewTotal: number;
  reviewStars: number;
  size?: 'medium' | 'large';
};

function StarRating(props: Props) {
  const { reviewTotal, reviewStars, size = 'large' } = props;

  const sendAnalyticsEvent = (element: string) => {
    analyticsEvent({
      gaCategory: 'Bazaarvoice RatingsAndReviews',
      gaAction: `Bazaarvoice : RatingsAndReviews : Review ${element} Click`,
      gaLabel: 'Product',
    });
  };

  const handleClick = (event: any, element: string) => {
    event.preventDefault();
    scrollElementIntoView(document.getElementById('ratings-and-reviews'));
    sendAnalyticsEvent(element);
  };

  return (
    <div className={styles.container} data-testid="rating-and-reviews-summary">
      <Rating
        dataTestId="rating-and-reviews-summary_rating"
        onClick={(event: React.MouseEvent) => handleClick(event, 'Star and Text')}
        rating={reviewStars}
        reviewLinkText={`${reviewTotal} reviews`}
        reviewLink="#"
        size={size}
      />
    </div>
  );
}

export default StarRating;
